import { Component, Input, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'fl-target-chose-class-item',
  templateUrl: './chose-class-item.component.html',
  styleUrls: ['./chose-class-item.component.scss'],
  standalone: false,
})
export class TargetChoseClassItemComponent {
  readonly label = input<string>(undefined);
  readonly value = input<number>(undefined);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() checked: boolean = true;

  readonly checkedChange = output<boolean>();
  readonly onChange = output<boolean>();

  change() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
    this.onChange.emit(this.checked);
  }
}
